import { render, staticRenderFns } from "./topicDetailChecks.vue?vue&type=template&id=5aac7c4e&scoped=true&"
import script from "./topicDetailChecks.vue?vue&type=script&lang=js&"
export * from "./topicDetailChecks.vue?vue&type=script&lang=js&"
import style0 from "./topicDetailChecks.vue?vue&type=style&index=0&id=5aac7c4e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aac7c4e",
  null
  
)

export default component.exports